import {CdFrequencyFactory} from './cd-frequency-factory';
import {CdFrequency} from '../../../interfaces/care/cd-care-plan/cd-frequency';
import {CdPrescription} from '../../../interfaces/care/cd-care-plan/cd-prescription';

export class CdPrescriptionFactory {

  /**
   *
   * @param cdPrescription
   */
  public static fromObject(cdPrescription: any): CdPrescription {
    return new class implements CdPrescription {
      cdCarePlanId: number = cdPrescription.c_care_plan_id;
      type: string = cdPrescription.type;
      definition: string = cdPrescription.definition;
      id: number = cdPrescription.id;
      parentId: number = cdPrescription.parent_id;
      name: string = cdPrescription.name;
      comment: string = cdPrescription.comment;
      cdFrequencies: CdFrequency[] =
        cdPrescription.c_frequencies ? CdFrequencyFactory.fromArray(cdPrescription.c_frequencies) : [];
    };
  }

  /**
   *
   * @param cdPrescriptions
   */
  public static fromArray(cdPrescriptions: any[]): CdPrescription[] {
    return cdPrescriptions.map(_cdPrescription => CdPrescriptionFactory.fromObject(_cdPrescription));
  }

}
